module.exports = __webpack_public_path__ + "assets/img/scss_order.089d9760.jpg";